module.exports = __webpack_public_path__ + "static/media/SalesRentalsIMG.5faf0198.png";